import { Attrs, MinzeElement } from 'minze'

export interface LvcFavoriteIcon {
  dataWidth: number
  dataHeight: number
}

export class LvcFavoriteIcon extends MinzeElement {
  attrs: Attrs = [
    ['data-width', 33],
    ['data-height', 32],
  ]
  html = () => `
  <svg width="${this.dataWidth}" height="${this.dataHeight}" viewBox="0 0 33 32" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M17.0274 26.8C19.2478 25.0176 21.6357 22.871 23.5279 20.7515C25.3481 18.8937 26.833 16.7422 27.9183 14.39C28.3801 13.3612 28.5718 12.2341 28.4759 11.1128C28.38 9.99148 27.9995 8.9121 27.3695 7.97435C26.7843 7.12798 26.0007 6.43374 25.0853 5.9507C24.1699 5.46767 23.1499 5.21013 22.112 5.20001C20.9346 5.23075 19.787 5.57273 18.7889 6.1903C17.8757 6.75538 17.0866 7.8357 16.5497 8.7549C15.9397 7.74367 15.0685 6.62973 13.9865 6.12645C12.8245 5.58597 11.7178 5.19506 10.4583 5.44364C9.07684 5.66472 7.59393 6.5234 6.57639 7.47205C5.55885 8.4207 4.85305 9.64902 4.55032 10.9981C4.36584 12.2689 4.69286 13.5605 5.46131 14.5961C6.47825 15.9368 7.57793 17.2144 8.7541 18.4216L12.9799 23.0166C14.0363 24.4341 15.5556 25.8073 17.0274 26.8Z" stroke="currentColor" stroke-width="2" stroke-linejoin="round"/>
  </svg>
  
  `

  css = () => `
    
  `
}
